import React from "react";

import classes from "./SubHeading.module.scss";

const SubHeading = (props) => <h2 style={{...props.style}} className={classes.SubHeading}>{props.children}</h2>;

export default SubHeading;
